const PLAYBOOK_WORKSPACE_TAG_KEY = "playbook"

export function isPlaybookWorkspaceTag(tagName: string): boolean {
  return tagName.trim().toLowerCase() === PLAYBOOK_WORKSPACE_TAG_KEY
}
